import { render, staticRenderFns } from "./RwConfirm.vue?vue&type=template&id=d3505fec&scoped=true&"
import script from "./RwConfirm.vue?vue&type=script&lang=ts&"
export * from "./RwConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./RwConfirm.vue?vue&type=style&index=0&id=d3505fec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3505fec",
  null
  
)

export default component.exports